import * as Models from "../../../Models";
import * as UserManagementApiClient from "./UserManagementApiClientService";

export interface IGroupSaveService {
  saveGroup: (group: Models.GroupModel.IGroupModel) => ng.IPromise<void>;
  deleteGroup: (groupId: string) => ng.IPromise<Models.BaseApiResponse.BaseApiResponse>;
}

export class GroupSaveService implements IGroupSaveService {
  public static $inject = ["UserManagementApiClientService"];

  constructor(
    private userManagementApiClientService: UserManagementApiClient.IUserManagementApiClientService
  ) {}

  public saveGroup = (group: Models.GroupModel.IGroupModel) => {
    return this.userManagementApiClientService.saveGroup(group);
  };

  public deleteGroup = (groupId: string): ng.IPromise<Models.BaseApiResponse.BaseApiResponse> =>  {
    return this.userManagementApiClientService.deleteGroup(groupId);
  };
}
